// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_TOPIC_DID_NOT_FIND_YOUR_MODERATOR_INVITATION_FOR_THIS_TOPIC = "Nena\u0161li jsme \u017e\u00e1dnou platnou pozv\u00e1nku";
export const THIS_TOPIC_HAS_NO_DESCRIPTION = "Tato kategorie zat\u00edm nem\u00e1 \u017e\u00e1dn\u00fd popis ani pravidla.";
export const TOPIC_DESCRIPTION_AND_RULES = "Popis a pravidla";
export const TOPIC_MODERATORS = "Moder\u00e1to\u0159i";
